import SIcon from "../../views/NUI/StreamlineIcons/SIcon";

const NotificationIndicator = ({
    onClick,
    open = false,
    unreadCount = 0,
}) => (
    <button
        onClick={onClick}
        title={`Notifications ${unreadCount > 0 ? `(${unreadCount} unread)` : ''}`}
        aria-label={`Notifications ${unreadCount > 0 ? `(${unreadCount} unread)` : ''}`}
        aria-expanded={open}
        aria-haspopup="true"
        data-toggle-notifications="true"
        data-testid="button-notifications"
        className={`
                notifications---indicator
                notifications---indicator--${open ? 'open' : 'closed'}
                ${open
                ? "bg-notifications-indicatorIcon-active bg-is2-blue-300"
                : "bg-transparent"}
                relative
                h-10 lg:h-[44px]
                py-2.5
                px-1 lg:pl-[15px] lg:pr-[6px]
                inline-flex
                items-center
                justify-center
                focus:outline-none
                ${!open ? "focus-visible:ring-1 focus-visible:ring-white" : ""}
                rounded-full
                !border-none
                group
            `}
    >
        <div className="hidden lg:block relative group-hover:no-underline after:absolute after:left-0 after:right-0 after:-bottom-[0px] after:h-[1px] after:bg-current after:opacity-0 group-hover:after:opacity-100 after:transition-opacity after:duration-200">Notifications</div>
        <span>
            <SIcon
                name="alarm-bell"
                cls="p-[9px]"
                svg_cls="h-[18px] w-[18px]"
                bold
                className={"text-notifications-indicatorIcon"}
            />
            {unreadCount > 0 && (
                <div
                    className="text-xs bg-is2-orange absolute -top-1 right-1 text-white rounded-full p-1 min-w-5 leading-none flex items-center justify-center"
                    aria-hidden="true"
                    data-testid="badge-notifications-count"
                >
                    {unreadCount > 99 ? '99+' : unreadCount}
                </div>
            )}
        </span>
    </button>
);

export default NotificationIndicator;
